const parseInt10 = (n: string): number => parseInt( n, 10 );
export const arrOf = (n: number) =>
    Object.keys(
        (new Array(n)).fill( void(0) )
    ).map( parseInt10 )
;
